import Vue from "vue";
import i18n from "@/locales";
import { uuid } from "vue-uuid";
import { checkResponse } from "@/helpers/store";
import {
  nameFirme,
  kindName,
  userName,
  streetName,
  regionName,
  serviceName,
  zoneName,
  payName,
  currencyShortName,
  errorName
} from "@/helpers/reference";

const state = {
  payment: {
    paymentModal: false,
    paymentSubscriber: {
      data: [],
      rows: 0
    },
    paymentSubscribers: {
      data: [],
      rows: 0
    },
    paymentActs: {
      data: [],
      rows: 0
    },
    paymentCounters: {
      cleargroupcntid: "",
      data: [],
      rows: 0
    },
    paymentErrors: {
      data: [],
      rows: 0
    },
    paymentOneError: {
      data: [],
      rows: 0
    },
    data: {
      state: "",
      npack: "",
      payid: "",
      date: "",
      sumPay: 0,
      kindpay: "",
      countpay: 0,
      note: ""
    },
    paymentCheck: null,
    paymentSubmit: null,
    paymentEdit: null,
    paymentCountersInit: false,
    paymentPostingError: null,
    paymentDelError: null,
    paymentRefreshErrors: null
  }
};

const mutations = {
  setPaymentModal: (state, payload) => (state.payment.paymentModal = payload),
  setPaymentSubscriberSearch: (state, payload) =>
    (state.payment.paymentSubscriber = payload),
  clearPaymentSubscriberSearch: state =>
    (state.payment.paymentSubscriber = { data: [], rows: 0 }),
  setPaymentSubscribersSearch: (state, payload) =>
    (state.payment.paymentSubscribers = payload),
  clearPaymentSubscribersSearch: state =>
    (state.payment.paymentSubscribers = { data: [], rows: 0 }),
  setPaymentActs: (state, payload) => (state.payment.paymentActs = payload),
  clearPaymentActs: state =>
    (state.payment.paymentActs = { data: [], rows: 0 }),
  setPaymentCounters: (state, payload) => {
    let items = [];
    payload.data.forEach(item => {
      item["id"] = uuid.v4();
      items.push(item);
    });
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data,
      ...items
    ];
    state.payment.paymentCounters.cleargroupcntid = payload.cleargroupcntid;
  },
  deleteFactualPaymentCounters: (state, topindex) => {
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data.map(item => {
        if (item.topindex === topindex) {
          item.status = "0";
          item.reading = "";
          item.behaviorstatus = "del";
        }
        return item;
      })
    ];
  },
  deleteAbstrctPaymentCounters: (state, topindex) => {
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data.filter(
        item => item.topindex !== topindex
      )
    ];
  },
  deleteNonexistPaymentCounters: (state, topindex) => {
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data.map(item => {
        if (item.topindex === topindex) {
          item.behaviorstatus = "del";
        }
        return item;
      })
    ];
  },
  changeOneTopindexPaymentCounters: (state, payload) => {
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data.map(item => {
        if (item.id === payload.id) {
          item.behaviorstatus = "edit";
          item.topindex = payload.newValue;
        }
        return item;
      })
    ];
  },
  changeManyTopindexPaymentCounters: (state, payload) => {
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data.map(item => {
        if (
          item.topindex === payload.oldValue &&
          (item.type === "1" || item.type === "2")
        ) {
          item.topindex = payload.newValue;

          if (item.behaviorstatus !== "add") {
            item.behaviorstatus = "edit";
          }
        }
        return item;
      })
    ];
  },
  changeReadingPaymentCounters: (state, payload) => {
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data.map(item => {
        if (item.id === payload.id) {
          item.reading = payload.newReading;

          if (item.paycntid !== "") {
            if (payload.newReading === "") {
              item.behaviorstatus = "del";
            } else if (payload.newReading === "0") {
              item.behaviorstatus = "del";
            } else if (payload.newReading !== "") {
              item.behaviorstatus = "edit";
            }
          } else if (item.paycntid === "") {
            if (payload.newReading !== "") {
              item.behaviorstatus = "add";
            }
          }
        }
        return item;
      })
    ];
  },
  changeStatusPaymentCounters: (state, payload) => {
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data.map(item => {
        if (item.id === payload.id) {
          item.status = payload.newStatus;

          if (item.behaviorstatus !== "add") {
            item.behaviorstatus = "edit";
          }
        }
        return item;
      })
    ];
  },
  clearPaymentCounters: state =>
    (state.payment.paymentCounters = {
      cleargroupcntid: "",
      data: [],
      rows: 0
    }),
  customClearPaymentCounters: state => {
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data.filter(item => item.type === "2")
    ];
  },
  smartClearPaymentCounters: state => {
    state.payment.paymentCounters.data = [
      ...state.payment.paymentCounters.data.filter(
        item => item.reading !== "" && item.reading !== "0"
      )
    ];
  },
  addPaymentCounters: (state, payload) =>
    state.payment.paymentCounters.data.push(payload),
  setPaymentData: (state, payload) => (state.payment.data = payload),
  clearPaymentData: state =>
    (state.payment.data = {
      state: "",
      npack: "",
      payid: "",
      date: "",
      sumPay: 0,
      kindpay: "",
      countpay: 0,
      note: ""
    }),
  setPaymentCheck: (state, payload) => (state.payment.paymentCheck = payload),
  clearPaymentCheck: state => (state.payment.checkPayment = null),
  setPaymentSubmit: (state, payload) => (state.payment.paymentSubmit = payload),
  clearPaymentSubmit: state => (state.payment.paymentSubmit = null),
  setPaymentErrors: (state, payload) => (state.payment.paymentErrors = payload),
  clearPaymentErrors: state =>
    (state.payment.paymentErrors = { data: [], rows: 0 }),
  setPaymentOneError: (state, payload) =>
    (state.payment.paymentOneError = payload),
  clearPaymentOneError: state =>
    (state.payment.paymentOneError = { data: [], rows: 0 }),
  setPaymentCountersInit: (state, payload) =>
    (state.payment.paymentCountersInit = payload),
  setPaymentPostingError: (state, payload) =>
    (state.payment.paymentPostingError = payload),
  clearPaymentPostingError: state => (state.payment.paymentPostingError = null),
  setPaymentDelError: (state, payload) =>
    (state.payment.paymentDelError = payload),
  clearPaymentDelError: state => (state.payment.paymentDelError = null),
  setPaymentRefreshErrors: (state, payload) =>
    (state.payment.paymentRefreshErrors = payload),
  clearPaymentEdit: state => (state.payment.paymentEdit = null),
  setPaymentEdit: (state, payload) => (state.payment.paymentEdit = payload)
};

const actions = {
  async paymentPostingError({ commit, rootState }, { payid }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbraznoserror",
            funcname: "wbraznoserror",
            payid: `${payid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentPostingError", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async paymentSubscriberSearch({ commit, rootState }, { abcode }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbabon",
            funcname: "wbRunSelect",
            abcode: `${abcode}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentSubscriberSearch", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async paymentSubscribersSearch(
    { commit, rootState },
    {
      extendedSearch,
      fullName,
      fullNameTypeSearch,
      streetCode,
      nHouse,
      charHouse,
      corpHouse,
      nFlat,
      charFlat,
      ncount,
      ncountTypeSearch,
      plombNumber,
      plombNumberTypeSearch,
      docnumber,
      docnumberTypeSearch,
      eic,
      eicTypeSearch,
      abcode,
      abcodeTypeSearch,
      dateBegin,
      dateEnd,
      districtCode,
      actNumber,
      actNumberTypeSearch,
      individualFullName,
      individualFullNameTypeSearch,
      requestId,
      accountNumber,
      contractNumber,
      contractNumberTypeSearch,
      phoneNumber,
      phoneNumberTypeSearch,
      houseAccountNumber,
      houseAccountNumberTypeSearch
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      let params = {
        script: "web.wbabon",
        funcname: "wbRunSelect"
      };

      if (fullName) {
        switch (fullNameTypeSearch) {
          case "0": // совпадение
            params["fio"] = `${fullName}`;
            break;
          case "1": // вхождение
            params["fiolike"] = `${fullName}`;
            break;
          case "2": // начинается на
            params["fiolikebegin"] = `${fullName}`;
            break;
          case "3": // заканчивается на
            params["fiolikeend"] = `${fullName}`;
            break;
        }
      }

      if (streetCode) params["codestreet"] = `${streetCode}`;

      if (nHouse > 0) params["nhouse"] = `${nHouse}`;
      if (charHouse) params["charhouse"] = `${charHouse}`;
      if (corpHouse) params["korpus"] = `${corpHouse}`;

      if (nFlat > 0) params["nflat"] = `${nFlat}`;
      if (charFlat) params["charflat"] = `${charFlat}`;

      if (ncount) {
        switch (ncountTypeSearch) {
          case "0": // совпадение
            params["pncount"] = `${ncount}`;
            break;
          case "1": // вхождение
            params["pncountlike"] = `${ncount}`;
            break;
          case "2": // начинается на
            params["pncountlikebegin"] = `${ncount}`;
            break;
          case "3": // заканчивается на
            params["pncountlikeend"] = `${ncount}`;
            break;
        }
      }

      if (plombNumber) {
        switch (plombNumberTypeSearch) {
          case "0": // совпадение
            params["plombnumber"] = `${plombNumber}`;
            break;
          case "1": // вхождение
            params["plombnumberlike"] = `${plombNumber}`;
            break;
          case "2": // начинается на
            params["plombnumberlikebegin"] = `${plombNumber}`;
            break;
          case "3": // заканчивается на
            params["plombnumberlikeend"] = `${plombNumber}`;
            break;
        }
      }

      if (extendedSearch) {
        if (docnumber) {
          switch (docnumberTypeSearch) {
            case "0": // совпадение
              params["docnumber"] = `${docnumber}`;
              break;
            case "1": // вхождение
              params["docnumberlike"] = `${docnumber}`;
              break;
            case "2": // начинается на
              params["docnumberlikebegin"] = `${docnumber}`;
              break;
            case "3": // заканчивается на
              params["docnumberlikeend"] = `${docnumber}`;
              break;
          }
        }

        if (eic) {
          switch (eicTypeSearch) {
            case "0": // совпадение
              params["peic"] = `${eic}`;
              break;
            case "1": // вхождение
              params["peiclike"] = `${eic}`;
              break;
            case "2": // начинается на
              params["peiclikebegin"] = `${eic}`;
              break;
            case "3": // заканчивается на
              params["peiclikeend"] = `${eic}`;
              break;
          }
        }

        if (abcode) {
          switch (abcodeTypeSearch) {
            case "0": // совпадение
              params["abcode"] = `${abcode}`;
              break;
            case "1": // вхождение
              params["abcodelike"] = `${abcode}`;
              break;
            case "2": // начинается на
              params["abcodelikebegin"] = `${abcode}`;
              break;
            case "3": // заканчивается на
              params["abcodelikeend"] = `${abcode}`;
              break;
          }
        }

        if (dateBegin) params["pdatecreate"] = `${dateBegin}`;
        if (dateEnd) params["pdateclose"] = `${dateEnd}`;

        if (districtCode) params["coder"] = `${districtCode}`;

        if (actNumber) {
          switch (actNumberTypeSearch) {
            case "0": // совпадение
              params["pnumberact"] = `${actNumber}`;
              break;
            case "1": // вхождение
              params["pnumberactlike"] = `${actNumber}`;
              break;
            case "2": // начинается на
              params["pnumberactlikebegin"] = `${actNumber}`;
              break;
            case "3": // заканчивается на
              params["pnumberactlikeend"] = `${actNumber}`;
              break;
          }
        }

        if (individualFullName) {
          switch (individualFullNameTypeSearch) {
            case "0": // совпадение
              params["fiofiz"] = `${individualFullName}`;
              break;
            case "1": // вхождение
              params["fiofizlike"] = `${individualFullName}`;
              break;
            case "2": // начинается на
              params["fiofizlikebegin"] = `${individualFullName}`;
              break;
            case "3": // заканчивается на
              params["fiofizlikeend"] = `${individualFullName}`;
              break;
          }
        }

        if (requestId > 0) params["prequestid"] = `${requestId}`;
        if (accountNumber > 0) params["pnumberaccount"] = `${accountNumber}`;

        if (contractNumber) {
          switch (contractNumberTypeSearch) {
            case "0": // совпадение
              params["pnumbercontract"] = `${contractNumber}`;
              break;
            case "1": // вхождение
              params["pnumbercontractlike"] = `${contractNumber}`;
              break;
            case "2": // начинается на
              params["pnumbercontractlikebegin"] = `${contractNumber}`;
              break;
            case "3": // заканчивается на
              params["pnumbercontractlikeend"] = `${contractNumber}`;
              break;
          }
        }

        if (phoneNumber) {
          switch (phoneNumberTypeSearch) {
            case "0": // совпадение
              params["phone"] = `${phoneNumber}`;
              break;
            case "1": // вхождение
              params["phonelike"] = `${phoneNumber}`;
              break;
            case "2": // начинается на
              params["phonelikebegin"] = `${phoneNumber}`;
              break;
            case "3": // заканчивается на
              params["phonelikeend"] = `${phoneNumber}`;
              break;
          }
        }

        if (houseAccountNumber) {
          switch (houseAccountNumberTypeSearch) {
            case "0": // совпадение
              params["pnumberhouses"] = `${houseAccountNumber}`;
              break;
            case "1": // вхождение
              params["pnumberhouseslike"] = `${houseAccountNumber}`;
              break;
            case "2": // начинается на
              params["pnumberhouseslikebegin"] = `${houseAccountNumber}`;
              break;
            case "3": // заканчивается на
              params["pnumberhouseslikeend"] = `${houseAccountNumber}`;
              break;
          }
        }
      }

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentSubscribersSearch", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPaymentActs({ commit, rootState }, { abcode }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbactfrompay",
            funcname: "wbRunSelect",
            abcode: `${abcode}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentActs", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPaymentCounters(
    { commit, state, rootState, rootGetters },
    { abcode, abcodeOld, dateSaveReadingsOld, dateSaveReadings, groupСntId }
  ) {
    try {
      commit("setFullPageLoading", true);

      let params = {};
      if (state.payment.paymentCountersInit) {
        // расчет имени скрипта в случае редактирования платежа из массового ввода
        const scriptName = rootGetters.isCountbandPayment
          ? "web.wbMVCounters"
          : "web.wbCounters";

        params = {
          script: scriptName,
          funcname: "wbRunSelectInit",
          abcode: `${abcode}`,
          dtSnyatPokazNew: `${dateSaveReadings}`,
          groupcntid: `${groupСntId}`
        };
      } else {
        // расчет объекта с параметрами в случае редактирования платежа из массового ввода
        if (rootGetters.isCountbandPayment) {
          params = {
            script: "web.wbMVCounters",
            funcname: "wbRunSelect",
            abcode: `${abcode}`,
            dtSnyatPokaz: `${dateSaveReadings}`,
            countersarray: JSON.stringify(state.payment.paymentCounters.data)
          };
        } else {
          params = {
            script: "web.wbCounters",
            funcname: "wbRunSelect",
            abcode: `${abcode}`,
            abcodeOld: `${abcodeOld}`,
            groupcntid: `${groupСntId}`,
            dtSnyatPokazOld: `${dateSaveReadingsOld}`,
            dtSnyatPokazNew: `${dateSaveReadings}`,
            countersarray: JSON.stringify(state.payment.paymentCounters.data)
          };
        }
      }

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("clearPaymentCounters");
        commit("setPaymentCounters", response.data);
        if (state.payment.paymentCountersInit) {
          commit("setPaymentCountersInit", false);
        }
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPaymentCheck(
    { commit, state, rootState },
    {
      behaviorstatus,
      abcode,
      datebank,
      typepay,
      summpay,
      datebegin,
      dateend,
      codeservice,
      kindpay
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      const paymentCountersFiltered = [
        ...state.payment.paymentCounters.data.filter(
          item =>
            item.reading !== "" &&
            item.reading !== "0" &&
            item.behaviorstatus !== "del"
        )
      ];

      const paymentCountersIsEmpty =
        paymentCountersFiltered.length > 0 ? "0" : "1";

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbPay",
            funcname: "wbRunChek",
            behaviorstatus: `${behaviorstatus}`,
            abcode: `${abcode}`,
            datebank: `${datebank}`,
            typepay: `${typepay}`,
            summpay: `${summpay}`,
            datebegin: `${datebegin}`,
            dateend: `${dateend}`,
            codeservice: `${codeservice}`,
            kindpay: `${kindpay}`,
            paymentcountersisempty: `${paymentCountersIsEmpty}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentCheck", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPaymentSubmit(
    { commit, state, rootState, rootGetters },
    {
      abcode,
      npack,
      dateclient,
      codeplat,
      coderr,
      summpay,
      paynum,
      summpayreq,
      datebegin,
      dateend,
      actid,
      mess,
      dateSaveReadings
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      // nband: добавление платежа в массовом вводе, передача номера бандероли, определение откуда вызвана форма
      const tmppay = {
        data: [
          {
            abcode: `${abcode}`,
            npack: `${npack}`,
            dateclient: `${dateclient}`,
            codeplat: `${codeplat}`,
            coderr: `${coderr}`,
            summpay: `${summpay}`,
            summpayreq: `${summpayreq}`,
            nband: rootGetters.isCountbandPayment
              ? rootState.packs.countbandPayment.nband
              : "",
            paynum: `${paynum}`,
            datebegin: `${datebegin}`,
            dateend: `${dateend}`,
            actid: `${actid}`,
            mess: `${mess}`
          }
        ]
      };

      const paymentCountersFiltered = [
        ...state.payment.paymentCounters.data.filter(
          item => item.reading !== "" && item.reading !== "0"
        )
      ];

      const paymentCountersChangeDate = [
        ...paymentCountersFiltered.map(item => {
          item.dateval = `${dateSaveReadings}`;
          return item;
        })
      ];

      const tpaycnttmp = {
        data: paymentCountersChangeDate
      };

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbPay",
            funcname: "runInsert",
            tmppay: JSON.stringify(tmppay),
            tpaycnttmp: JSON.stringify(tpaycnttmp)
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentSubmit", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPaymentEdit(
    { commit, state, rootState },
    {
      payid,
      paynum,
      dateclient,
      groupcntid,
      codeplat,
      coderr,
      datebegin,
      dateend,
      payinfoid,
      abcode,
      prim,
      tskey,
      dateSaveReadings
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      const tmppay = {
        data: [
          {
            payid: `${payid}`,
            paynum: `${paynum}`,
            dateclient: `${dateclient}`,
            groupcntid: `${groupcntid}`,
            codeplat: `${codeplat}`,
            coderr: `${coderr}`,
            datebegin: `${datebegin}`,
            dateend: `${dateend}`,
            payinfoid: `${payinfoid}`,
            abcode: `${abcode}`,
            prim: `${prim}`,
            tskey: `${tskey}`
          }
        ]
      };

      const paymentCountersFiltered = [
        ...state.payment.paymentCounters.data.filter(
          item =>
            item.behaviorstatus !== "add" ||
            (item.reading !== "" && item.reading !== "0")
        )
      ];

      const paymentCountersChangeDate = [
        ...paymentCountersFiltered.map(item => {
          item.dateval = `${dateSaveReadings}`;
          return item;
        })
      ];

      const tpaycnttmp = {
        data: paymentCountersChangeDate
      };

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbPay",
            funcname: "runEdit",
            tmppay: JSON.stringify(tmppay),
            tpaycnttmp: JSON.stringify(tpaycnttmp)
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentEdit", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getMVPaymentEdit(
    { commit, state, rootState },
    {
      abcode,
      dateclient,
      summpay,
      paynum,
      codeplat,
      coderr,
      datebegin,
      dateend,
      summpayreq,
      actid,
      actprim,
      groupcntid,
      nop,
      tskey,
      dateSaveReadings
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      const tmppay = {
        data: [
          {
            abcode: `${abcode}`,
            dateclient: `${dateclient}`,
            summpay: `${summpay}`,
            paynum: `${paynum}`,
            codeplat: `${codeplat}`,
            coderr: `${coderr}`,
            datebegin: `${datebegin}`,
            dateend: `${dateend}`,
            summpayreq: `${summpayreq}`,
            actid: `${actid}`,
            actprim: `${actprim}`,
            groupcntid: `${groupcntid}`,
            nop: `${nop}`,
            tskey: `${tskey}`
          }
        ]
      };

      const paymentCountersFiltered = [
        ...state.payment.paymentCounters.data.filter(
          item =>
            item.behaviorstatus !== "add" ||
            (item.reading !== "" && item.reading !== "0")
        )
      ];

      const paymentCountersChangeDate = [
        ...paymentCountersFiltered.map(item => {
          item.dateval = `${dateSaveReadings}`;
          return item;
        })
      ];

      const tpaycnttmp = {
        data: paymentCountersChangeDate
      };

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbmassvvod",
            funcname: "runEdit",
            tmppay: JSON.stringify(tmppay),
            tpaycnttmp: JSON.stringify(tpaycnttmp)
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentEdit", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPaymentErrors(
    { commit, rootState },
    {
      perror,
      abcode,
      abcodeTypeSearch,
      sumPayBegin,
      sumPayEnd,
      sumPayTypeSearch,
      dateBankBegin,
      dateBankEnd,
      dateBankTypeSearch,
      datePayBegin,
      datePayEnd,
      datePayTypeSearch,
      dateChangeBegin,
      dateChangeEnd,
      dateChangeTypeSearch,
      errorType,
      npack,
      datePayFrom,
      datePayTo,
      kindpay,
      codefirme,
      note,
      noteTypeSearch
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      let params = {
        script: "web.wberrorpay", // "web.wberrorpaytest" - тестовый, "web.wberrorpay" - рабочий
        funcname: "wbRunGridSelect",
        perror: `${perror}`,
        limit: `${rootState.util.limitRecords.defRet}`
        // ptimeout: "2" // ### тестовый, таймаут при запросе
      };

      if (abcode) {
        switch (abcodeTypeSearch) {
          case "0": // совпадение
            params["abcode"] = `${abcode}`;
            break;
          case "1": // вхождение
            params["abcodelike"] = `${abcode}`;
            break;
          case "2": // начинается на
            params["abcodebegin"] = `${abcode}`;
            break;
          case "3": // заканчивается на
            params["abcodeend"] = `${abcode}`;
            break;
        }
      }

      if (sumPayBegin || sumPayEnd) {
        switch (sumPayTypeSearch) {
          case "0": // равна
            params["summa"] = `${sumPayBegin}`;
            break;
          case "1": // между
            params["summabegin"] = `${sumPayBegin}`;
            params["summaend"] = `${sumPayEnd}`;
            break;
        }
      }

      if (dateBankBegin || dateBankEnd) {
        switch (dateBankTypeSearch) {
          case "0": // равна
            params["datebank"] = `${dateBankBegin}`;
            break;
          case "1": // между
            params["datebankbegin"] = `${dateBankBegin}`;
            params["datebankend"] = `${dateBankEnd}`;
            break;
        }
      }

      if (datePayBegin || datePayEnd) {
        switch (datePayTypeSearch) {
          case "0": // равна
            params["dateclient"] = `${datePayBegin}`;
            break;
          case "1": // между
            params["dateclientbegin"] = `${datePayBegin}`;
            params["dateclientend"] = `${datePayEnd}`;
            break;
        }
      }

      if (dateChangeBegin || dateChangeEnd) {
        switch (dateChangeTypeSearch) {
          case "0": // равна
            params["datebeginfact"] = `${dateChangeBegin}`;
            break;
          case "1": // между
            params["datebeginfactbegin"] = `${dateChangeBegin}`;
            params["datebeginfactend"] = `${dateChangeEnd}`;
            break;
        }
      }

      if (errorType) params["coderr"] = `${errorType}`;
      if (npack) params["npack"] = `${npack}`;
      if (datePayFrom) params["datebegin"] = `${datePayFrom}`;
      if (datePayTo) params["dateend"] = `${datePayTo}`;
      if (kindpay) params["kindpay"] = `${kindpay}`;
      if (codefirme) params["codefirme"] = `${codefirme}`;

      if (note) {
        switch (noteTypeSearch) {
          case "0": // совпадение
            params["comment"] = `${note}`;
            break;
          case "1": // вхождение
            params["commentlike"] = `${note}`;
            break;
          case "2": // начинается на
            params["commentbegin"] = `${note}`;
            break;
          case "3": // заканчивается на
            params["commentend"] = `${note}`;
            break;
        }
      }

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentErrors", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPaymentOneError({ commit, rootState }, { perror, payid }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wberrorpay",
            funcname: "wbRunSelect",
            perror: `${perror}`,
            payid: `${payid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentOneError", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPaymentDelError(
    { commit, rootState },
    {
      payid,
      paynum,
      dateclient,
      groupcntid,
      codeplat,
      coderr,
      datebegin,
      dateend,
      payinfoid,
      abcode,
      comment
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      const tmppay = {
        data: [
          {
            payid: `${payid}`,
            paynum: `${paynum}`,
            dateclient: `${dateclient}`,
            groupcntid: `${groupcntid}`,
            codeplat: `${codeplat}`,
            coderr: `${coderr}`,
            datebegin: `${datebegin}`,
            dateend: `${dateend}`,
            payinfoid: `${payinfoid}`,
            abcode: `${abcode}`,
            comment: `${comment}`
          }
        ]
      };

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbPay",
            funcname: "runStorn",
            tmppay: JSON.stringify(tmppay)
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentDelError", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  paymentModal: state => state.payment.paymentModal,
  paymentSubscriber: (state, rootState) => {
    let items = [];
    state.payment.paymentSubscriber.data.forEach(item => {
      let address = "";
      address += `${regionName(rootState.params.gregion.data, item.coder)}, `;
      address += `${item.typestr} ${streetName(
        rootState.params.street.data,
        item.codestreet
      )}`;
      if (item.nhouse !== "0") {
        address += `${i18n.t("common.address.house")}${item.nhouse}`;
      }
      if (item.charhouse) {
        address += `/${item.charhouse}`;
      }
      if (item.nflat !== "" && item.nflat !== "0") {
        address += `${i18n.t("common.address.flat")}${item.nflat}`;
      }
      if (item.charflat) {
        address += `/${item.charflat}`;
      }
      item["address"] = address;
      items.push(item);
    });
    return items;
  },
  paymentSubscribers: (state, rootState) => {
    let items = [];
    state.payment.paymentSubscribers.data.forEach(item => {
      item["streetname"] = streetName(
        rootState.params.street.data,
        item.codestreet
      );
      item["regionname"] = regionName(
        rootState.params.gregion.data,
        item.coder
      );
      items.push(item);
    });
    return items;
  },
  paymentActs: state => state.payment.paymentActs,
  paymentCounters: (state, rootState) => {
    let items = [];
    state.payment.paymentCounters.data.forEach(item => {
      item["service"] = serviceName(
        rootState.params.gservice.data,
        item.codeservice
      );
      item["zone"] = zoneName(
        rootState.params.gzone.data,
        item.zoneheadid,
        item.zoneindex
      );

      if (item.behaviorstatus === "del" && item.type === "2") {
        return;
      }

      items.push(item);
    });
    return items;
  },
  paymentCountersClearGroupCntId: state =>
    state.payment.paymentCounters.cleargroupcntid,
  paymentData: state => state.payment.data,
  paymentCheck: state => state.payment.paymentCheck,
  paymentSubmit: state => state.payment.paymentSubmit,
  paymentEdit: state => state.payment.paymentEdit,
  paymentErrors: (state, rootState) => {
    let items = [];
    state.payment.paymentErrors.data.forEach(item => {
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      item["username"] = userName(rootState.params.gusers.data, item.userid);
      item["payname"] = payName(rootState.params.codepay.data, item.codeplat);
      item["currencyname"] = currencyShortName(
        rootState.params.gcurrency.data,
        item.codecurrency
      );
      item["errorname"] = errorName(
        rootState.params.statuspay.data,
        item.coderr
      );
      items.push(item);
    });
    return items;
  },
  paymentOneError: state => state.payment.paymentOneError,
  paymentPostingError: state => state.payment.paymentPostingError,
  paymentDelError: state => state.payment.paymentDelError,
  paymentRefreshErrors: state => state.payment.paymentRefreshErrors
};

export default { state, mutations, actions, getters };
